// CrearAnuncio.js
import React, { useState, useEffect } from "react";

function CrearAnuncio({ usuario, alVolver, alCompletar }) {
  const [paso, setPaso] = useState(1);
  const [comprobante, setComprobante] = useState(null);
  const [anuncioGuardadoId, setAnuncioGuardadoId] = useState(null);
  const [enlacePagoCripto, setEnlacePagoCripto] = useState("");

  // Nuevo estado para almacenar la imagen QR generada dinámicamente por la API
  const [qrImagenBase64, setQrImagenBase64] = useState("");

  const [nombre, setNombre] = useState(usuario?.nombre || "");
  const [nic, setNic] = useState("");
  const [edad, setEdad] = useState("21");
  const [telefono, setTelefono] = useState("");

  const [pais, setPais] = useState("Bolivia");
  const [departamento, setDepartamento] = useState("La Paz");

  const [estatura, setEstatura] = useState("1.65");
  const [cuerpo, setCuerpo] = useState("Atlética");
  const [cabello, setCabello] = useState("Negro");
  const [servicios, setServicios] = useState(["Independiente"]);
  const [dias, setDias] = useState([
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ]);

  const [horaInicio, setHoraInicio] = useState("08:00");
  const [horaFin, setHoraFin] = useState("22:00");

  const [precio30min, setPrecio30min] = useState("50");
  const [precio1hora, setPrecio1hora] = useState("300");
  const [precioNoche, setPrecioNoche] = useState("1000");

  const [descripcion, setDescripcion] = useState("");
  const [fotos, setFotos] = useState([]);
  const [tipoPlanSeleccionado, setTipoPlanSeleccionado] =
    useState("semana_7dias");
  const [comprobanteEnviado, setComprobanteEnviado] = useState(false);

  const listadoPaises = {
    Bolivia: [
      "La Paz",
      "Santa Cruz",
      "Cochabamba",
      "Oruro",
      "Potosí",
      "Tarija",
      "Sucre",
      "Beni",
      "Pando",
    ],
    Chile: [
      "Arica y Parinacota",
      "Tarapacá",
      "Antofagasta",
      "Atacama",
      "Coquimbo",
      "Valparaíso",
      "Santiago",
      "O'Higgins",
      "Maule",
      "Ñuble",
      "Biobío",
      "La Araucanía",
      "Los Ríos",
      "Los Lagos",
      "Aysén",
      "Magallanes",
    ],
    Argentina: [
      "Buenos Aires",
      "Catamarca",
      "Chaco",
      "Chubut",
      "Córdoba",
      "Corrientes",
      "Entre Ríos",
      "Formosa",
      "Jujuy",
      "La Pampa",
      "La Rioja",
      "Mendoza",
      "Misiones",
      "Neuquén",
      "Río Negro",
      "Salta",
      "San Juan",
      "San Luis",
      "Santa Cruz",
      "Santa Fe",
      "Santiago del Estero",
      "Tierra del Fuego",
      "Tucumán",
    ],
    Colombia: [
      "Amazonas",
      "Antioquia",
      "Arauca",
      "Atlántico",
      "Bogotá D.C.",
      "Bolívar",
      "Boyacá",
      "Caldas",
      "Caquetá",
      "Casanare",
      "Cauca",
      "Cesar",
      "Chocó",
      "Córdoba",
      "Cundinamarca",
      "Guainía",
      "Guaviare",
      "Huila",
      "La Guajira",
      "Magdalena",
      "Meta",
      "Nariño",
      "Norte de Santander",
      "Putumayo",
      "Quindío",
      "Risaralda",
      "San Andrés y Providencia",
      "Santander",
      "Sucre",
      "Tolima",
      "Valle del Cauca",
      "Vaupés",
      "Vichada",
    ],
    Perú: [
      "Amazonas",
      "Áncash",
      "Apurímac",
      "Arequipa",
      "Ayacucho",
      "Cajamarca",
      "Callao",
      "Cusco",
      "Huancavelica",
      "Huánuco",
      "Ica",
      "Junín",
      "La Libertad",
      "Lambayeque",
      "Lima",
      "Loreto",
      "Madre de Dios",
      "Moquegua",
      "Pasco",
      "Piura",
      "Puno",
      "San Martín",
      "Tacna",
      "Tumbes",
      "Ucayali",
    ],
  };

  const opcionesEdades = Array.from({ length: 33 }, (_, i) =>
    (18 + i).toString()
  );
  const opcionesCuerpo = ["Delgado", "Atlético", "Curvilínea", "Rellenita"];
  const opcionesCabello = ["Negro", "Castaño", "Rubio", "Pelirrojo"];
  const opcionesServicios = [
    "Independiente",
    "Acompañante",
    "Masajes Eróticos",
    "Viajes",
    "Eventos",
    "Sexo Oral",
    "Sexo Vaginal",
    "Sexo Anal",
    "Ducha",
    "Masturbación",
    "Trios",
    "Garganta Profunda",
    "Despedida de soltero",
    "Frances Completo",
    "Striptease",
    "Swingers",
    "Arnés",
    "69",
    "Lesbico",
    "Juguetes Sexuales",
    "Tratos de Novios",
    "Besos con lengua",
    "Pack de Videos",
    "Juegos Eróticos",
    "Llamadas Hot",
    "Chat Hot",
    "Atencion a Parejas",
  ];
  const opcionesDias = [
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];
  const opcionesEstatura = Array.from({ length: 46 }, (_, i) =>
    (1.45 + i * 0.01).toFixed(2)
  );
  const opcionesHoras = Array.from(
    { length: 24 },
    (_, i) => `${i.toString().padStart(2, "0")}:00`
  );

  const toggleSeleccion = (item, lista, setLista) => {
    if (lista.includes(item)) {
      setLista(lista.filter((i) => i !== item));
    } else {
      setLista([...lista, item]);
    }
  };

  const manejarFotos = (e) => {
    const archivos = Array.from(e.target.files);
    if (archivos.length + fotos.length > 3) {
      alert("Solo puedes subir hasta 3 fotografías por anuncio.");
      return;
    }
    setFotos([...fotos, ...archivos]);
  };

  const eliminarFoto = (index) => {
    setFotos(fotos.filter((_, i) => i !== index));
  };

  // Función para solicitar el QR automatizado al backend
  const solicitarQrPago = async (anuncioId, tipoPlan) => {
    let monto = 19; // Plan 7 días
    if (tipoPlan === "mes_30dias") monto = 59;
    if (tipoPlan === "vip_30dias") monto = 99;

    try {
      const res = await fetch(
        "https://micontenidohot.com/generar_qr_pago.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ anuncio_id: anuncioId, monto: monto }),
        }
      );
      const data = await res.json();
      if (data.success) {
        setQrImagenBase64(data.qr_image);
      } else {
        console.warn(data.mensaje || "No se pudo generar el QR automático");
      }
    } catch (err) {
      console.error("Error de conexión al generar QR de pago", err);
    }
  };

  // 🚀 FUNCIÓN DE MONITOREO (POLLING) QUE FALTABA
  const iniciarMonitoreoPago = (idAnuncio) => {
    const intervalo = setInterval(async () => {
      try {
        const res = await fetch(
          `https://micontenidohot.com/verificar_pago.php?anuncio_id=${idAnuncio}`
        );
        const data = await res.json();

        if (data.status === "activo") {
          clearInterval(intervalo);
          setComprobanteEnviado(true); // Esto activará automáticamente la pantalla de éxito 🎉
        }
      } catch (error) {
        console.error("Error al verificar el pago:", error);
      }
    }, 5000); // Consulta la base de datos cada 5 segundos
  };

  const manejarEnvio = async () => {
    if (fotos.length === 0) {
      alert("Debes subir al menos 1 foto.");
      return;
    }

    const formData = new FormData();
    formData.append("user_id", usuario.id);
    formData.append("nombre", nombre);
    formData.append("nic", nic);
    formData.append("edad", edad);
    formData.append("telefono", telefono);
    formData.append("departamento", departamento);
    formData.append("pais", pais);
    formData.append("estatura", estatura + " m");
    formData.append("cuerpo", cuerpo);
    formData.append("cabello", cabello);
    formData.append("servicios", servicios.join(", "));
    formData.append("horario", `${horaInicio} a ${horaFin}`);
    formData.append("dias", dias.join(", "));
    formData.append("precio_30min", precio30min);
    formData.append("precio_1hour", precio1hora);
    formData.append("precio_noche", precioNoche);
    formData.append("descripcion", descripcion);
    formData.append("tipo_plan", tipoPlanSeleccionado);

    fotos.forEach((foto, idx) => {
      formData.append(`foto_${idx + 1}`, foto);
    });

    try {
      const res = await fetch("https://micontenidohot.com/crear_anuncio.php", {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (data.success) {
        setAnuncioGuardadoId(data.id_anuncio);
        if (data.invoice_url) {
          setEnlacePagoCripto(data.invoice_url);
        }
        setPaso(3);

        // Solicitar QR de Veripagos
        solicitarQrPago(data.id_anuncio, tipoPlanSeleccionado);

        // 🚀 INICIAR MONITOREO AUTOMÁTICO EN SEGUNDO PLANO
        iniciarMonitoreoPago(data.id_anuncio);
      } else {
        alert(data.mensaje || "Error al guardar el anuncio.");
      }
    } catch (err) {
      alert("Error de conexión con el servidor.");
    }
  };

  const enviarComprobanteFinal = async () => {
    if (!comprobante) {
      alert("Por favor, sube la imagen de tu comprobante de pago.");
      return;
    }

    const formData = new FormData();
    formData.append("anuncio_id", anuncioGuardadoId);
    formData.append("comprobante", comprobante);

    try {
      const res = await fetch(
        "https://micontenidohot.com/guardar_comprobante.php",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();

      if (data.success) {
        setComprobanteEnviado(true);
      } else {
        alert(data.mensaje || "Error al guardar el comprobante.");
      }
    } catch (err) {
      alert("Error de conexión con el servidor al subir el comprobante.");
    }
  };

  return (
    <div
      className="crear-anuncio-wrapper"
      style={{
        padding: "24px 16px",
        width: "100%",
        maxWidth: "700px",
        margin: "0 auto",
        boxSizing: "border-box",
        background: "#fff",
        borderRadius: "0px",
        height: "100vh",
        overflowY: "auto",
        color: "#0f172a",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          borderBottom: "1px solid #e2e8f0",
          paddingBottom: "12px",
        }}
      >
        <button
          onClick={alVolver}
          style={{
            border: "none",
            background: "#f1f5f9",
            padding: "8px 14px",
            borderRadius: "8px",
            color: "#0f172a",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          ← Volver
        </button>
        <h2
          style={{
            fontSize: "1.25rem",
            color: "#ff2c55",
            margin: 0,
            fontWeight: "800",
          }}
        >
          {paso === 1
            ? "Crear Nuevo Anuncio"
            : paso === 2
            ? "Seleccionar Plan"
            : "Pago de Activación"}
        </h2>
      </div>

      {paso === 1 && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setPaso(2);
          }}
          style={{ display: "flex", flexDirection: "column", gap: "14px" }}
        >
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
                Nombre Completo
              </label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                required
                placeholder="Nombre real"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                  marginTop: "4px",
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
                NIC / Alias (Público)
              </label>
              <input
                type="text"
                value={nic}
                onChange={(e) => setNic(e.target.value)}
                required
                placeholder="Ej. Valeria Sex"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                  marginTop: "4px",
                }}
              />
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              Edad
            </label>
            <div
              style={{
                display: "flex",
                gap: "6px",
                overflowX: "auto",
                paddingBottom: "6px",
                marginTop: "4px",
              }}
            >
              {opcionesEdades.map((num) => (
                <button
                  key={num}
                  type="button"
                  onClick={() => setEdad(num)}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "20px",
                    border: "1px solid #ff2c55",
                    background: edad === num ? "#ff2c55" : "#fff",
                    color: edad === num ? "#fff" : "#ff2c55",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  {num}
                </button>
              ))}
            </div>
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
                Teléfono / WhatsApp
              </label>
              <input
                type="text"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                required
                placeholder="72974157"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                  marginTop: "4px",
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
                Estatura (m)
              </label>
              <select
                value={estatura}
                onChange={(e) => setEstatura(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                  marginTop: "4px",
                  background: "#fff",
                }}
              >
                {opcionesEstatura.map((val) => (
                  <option key={val} value={val}>
                    {val} m
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              Días Disponibles
            </label>
            <div
              style={{
                display: "flex",
                gap: "6px",
                flexWrap: "wrap",
                marginTop: "4px",
              }}
            >
              {opcionesDias.map((d) => {
                const activo = dias.includes(d);
                return (
                  <button
                    key={d}
                    type="button"
                    onClick={() => toggleSeleccion(d, dias, setDias)}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "8px",
                      border: activo
                        ? "1px solid #10b981"
                        : "1px solid #cbd5e1",
                      background: activo ? "#ecfdf5" : "#f8fafc",
                      color: activo ? "#047857" : "#334155",
                      fontSize: "0.75rem",
                      cursor: "pointer",
                    }}
                  >
                    {d}
                  </button>
                );
              })}
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              Horas Disponibles
            </label>
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                marginTop: "4px",
              }}
            >
              <div style={{ flex: 1 }}>
                <span style={{ fontSize: "0.75rem", color: "#64748b" }}>
                  Desde:
                </span>
                <select
                  value={horaInicio}
                  onChange={(e) => setHoraInicio(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                    marginTop: "2px",
                    background: "#fff",
                  }}
                >
                  {opcionesHoras.map((h) => (
                    <option key={h} value={h}>
                      {h}
                    </option>
                  ))}
                </select>
              </div>
              <span style={{ marginTop: "16px", fontWeight: "bold" }}>a</span>
              <div style={{ flex: 1 }}>
                <span style={{ fontSize: "0.75rem", color: "#64748b" }}>
                  Hasta:
                </span>
                <select
                  value={horaFin}
                  onChange={(e) => setHoraFin(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                    marginTop: "2px",
                    background: "#fff",
                  }}
                >
                  {opcionesHoras.map((h) => (
                    <option key={h} value={h}>
                      {h}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              País
            </label>
            <div
              style={{
                display: "flex",
                gap: "6px",
                flexWrap: "wrap",
                marginTop: "4px",
              }}
            >
              {Object.keys(listadoPaises).map((p) => (
                <button
                  key={p}
                  type="button"
                  onClick={() => {
                    setPais(p);
                    setDepartamento(listadoPaises[p][0]);
                  }}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "20px",
                    border: "1px solid #cbd5e1",
                    background: pais === p ? "#ff2c55" : "#f8fafc",
                    color: pais === p ? "#fff" : "#334155",
                    fontSize: "0.8rem",
                    cursor: "pointer",
                    fontWeight: pais === p ? "bold" : "normal",
                  }}
                >
                  {p}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              Departamento / Región ({pais})
            </label>
            <div
              style={{
                display: "flex",
                gap: "6px",
                flexWrap: "wrap",
                marginTop: "4px",
                maxHeight: "150px",
                overflowY: "auto",
                padding: "4px",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
              }}
            >
              {listadoPaises[pais].map((dep) => (
                <button
                  key={dep}
                  type="button"
                  onClick={() => setDepartamento(dep)}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "20px",
                    border: "1px solid #cbd5e1",
                    background: departamento === dep ? "#0f172a" : "#f8fafc",
                    color: departamento === dep ? "#fff" : "#334155",
                    fontSize: "0.8rem",
                    cursor: "pointer",
                  }}
                >
                  {dep}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              Tipo de Cuerpo
            </label>
            <div
              style={{
                display: "flex",
                gap: "6px",
                flexWrap: "wrap",
                marginTop: "4px",
              }}
            >
              {opcionesCuerpo.map((item) => (
                <button
                  key={item}
                  type="button"
                  onClick={() => setCuerpo(item)}
                  style={{
                    padding: "6px 12px",
                    borderRadius: "20px",
                    border: "1px solid #cbd5e1",
                    background: cuerpo === item ? "#ff2c55" : "#f8fafc",
                    color: cuerpo === item ? "#fff" : "#334155",
                    fontSize: "0.8rem",
                    cursor: "pointer",
                  }}
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              Tipos de Servicio
            </label>
            <div
              style={{
                display: "flex",
                gap: "6px",
                flexWrap: "wrap",
                marginTop: "4px",
              }}
            >
              {opcionesServicios.map((s) => {
                const activo = servicios.includes(s);
                return (
                  <button
                    key={s}
                    type="button"
                    onClick={() => toggleSeleccion(s, servicios, setServicios)}
                    style={{
                      padding: "6px 12px",
                      borderRadius: "20px",
                      border: activo
                        ? "1px solid #ff2c55"
                        : "1px solid #cbd5e1",
                      background: activo ? "#ff2c55" : "#f8fafc",
                      color: activo ? "#fff" : "#334155",
                      fontSize: "0.8rem",
                      cursor: "pointer",
                    }}
                  >
                    {s}
                  </button>
                );
              })}
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              Precios / Tarifas
            </label>
            <div style={{ display: "flex", gap: "8px", marginTop: "4px" }}>
              <div style={{ flex: 1 }}>
                <span style={{ fontSize: "0.7rem", color: "#64748b" }}>
                  30 minutos
                </span>
                <input
                  type="number"
                  placeholder="30 min"
                  value={precio30min}
                  onChange={(e) => setPrecio30min(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                    fontSize: "0.8rem",
                    marginTop: "2px",
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <span style={{ fontSize: "0.7rem", color: "#64748b" }}>
                  Hora
                </span>
                <input
                  type="number"
                  placeholder="1 hora"
                  value={precio1hora}
                  onChange={(e) => setPrecio1hora(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                    fontSize: "0.8rem",
                    marginTop: "2px",
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <span style={{ fontSize: "0.7rem", color: "#64748b" }}>
                  Salida
                </span>
                <input
                  type="number"
                  placeholder="Noche"
                  value={precioNoche}
                  onChange={(e) => setPrecioNoche(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "8px",
                    border: "1px solid #cbd5e1",
                    fontSize: "0.8rem",
                    marginTop: "2px",
                  }}
                />
              </div>
            </div>
          </div>

          <div>
            <label style={{ fontSize: "0.8rem", fontWeight: "bold" }}>
              Descripción del Anuncio
            </label>
            <textarea
              rows="3"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Escribe detalles sobre tu atención..."
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "10px",
                border: "1px solid #cbd5e1",
                marginTop: "4px",
                fontSize: "0.85rem",
              }}
            />
          </div>

          <div
            style={{
              background: "#f8fafc",
              padding: "12px",
              borderRadius: "12px",
              border: "1px dashed #cbd5e1",
            }}
          >
            <label
              style={{
                fontSize: "0.8rem",
                fontWeight: "bold",
                display: "block",
                marginBottom: "6px",
              }}
            >
              Fotos del Anuncio (Máximo 3)
            </label>
            {fotos.length < 3 && (
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={manejarFotos}
                style={{ fontSize: "0.8rem" }}
              />
            )}
            <div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
              {fotos.map((f, i) => (
                <div
                  key={i}
                  style={{
                    position: "relative",
                    width: "60px",
                    height: "60px",
                  }}
                >
                  <img
                    src={URL.createObjectURL(f)}
                    alt="preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => eliminarFoto(i)}
                    style={{
                      position: "absolute",
                      top: "-5px",
                      right: "-5px",
                      background: "#e11d48",
                      color: "#fff",
                      border: "none",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                      fontSize: "0.65rem",
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          </div>

          <button
            type="submit"
            className="btn-create-account"
            style={{ marginTop: "10px" }}
          >
            Continuar a Selección de Plan →
          </button>
        </form>
      )}

      {paso === 2 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            textAlign: "center",
          }}
        >
          <h3>Paso 2: Selecciona tu plan de publicación</h3>
          <p style={{ fontSize: "0.9rem", color: "#64748b" }}>
            Selecciona el plan para la publicación de tu anuncio:
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "10px",
            }}
          >
            <button
              type="button"
              onClick={() => setTipoPlanSeleccionado("semana_7dias")}
              style={{
                padding: "15px 10px",
                borderRadius: "12px",
                border:
                  tipoPlanSeleccionado === "semana_7dias"
                    ? "2px solid #ff2c55"
                    : "1px solid #cbd5e1",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              <h4 style={{ margin: "0 0 5px 0", fontSize: "0.9rem" }}>
                Plan 7 Días
              </h4>
              <p style={{ margin: 0, fontWeight: "bold", color: "#ff2c55" }}>
                19 Bs
              </p>
            </button>

            <button
              type="button"
              onClick={() => setTipoPlanSeleccionado("mes_30dias")}
              style={{
                padding: "15px 10px",
                borderRadius: "12px",
                border:
                  tipoPlanSeleccionado === "mes_30dias"
                    ? "2px solid #ff2c55"
                    : "1px solid #cbd5e1",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              <h4 style={{ margin: "0 0 5px 0", fontSize: "0.9rem" }}>
                Plan 30 Días
              </h4>
              <p style={{ margin: 0, fontWeight: "bold", color: "#ff2c55" }}>
                59 Bs
              </p>
            </button>

            <button
              type="button"
              onClick={() => setTipoPlanSeleccionado("vip_30dias")}
              style={{
                padding: "15px 10px",
                borderRadius: "12px",
                border:
                  tipoPlanSeleccionado === "vip_30dias"
                    ? "2px solid #ff2c55"
                    : "1px solid #cbd5e1",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              <h4 style={{ margin: "0 0 5px 0", fontSize: "0.9rem" }}>
                Plan VIP 30 Días
              </h4>
              <p style={{ margin: 0, fontWeight: "bold", color: "#ff2c55" }}>
                99 Bs
              </p>
            </button>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              onClick={() => setPaso(1)}
              style={{
                padding: "10px 20px",
                background: "#ccc",
                border: "none",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              ⬅ Atrás
            </button>
            <button
              type="button"
              onClick={() => {
                if (!tipoPlanSeleccionado) {
                  alert("Por favor, selecciona un plan para continuar.");
                  return;
                }
                manejarEnvio();
              }}
              style={{
                padding: "10px 20px",
                background: "#ff2c55",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              Publicar y Pagar ↗
            </button>
          </div>
        </div>
      )}

      {paso === 3 && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            textAlign: "center",
            padding: "10px 0",
          }}
        >
          {!comprobanteEnviado ? (
            <>
              <div
                style={{
                  background: "#f8fafc",
                  padding: "16px",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <h3
                  style={{
                    color: "#0f172a",
                    fontSize: "1.1rem",
                    marginBottom: "6px",
                  }}
                >
                  ¡Anuncio registrado con éxito!
                </h3>
                <p
                  style={{
                    fontSize: "0.85rem",
                    color: "#64748b",
                    lineHeight: "1.4",
                    margin: 0,
                  }}
                >
                  Escanea el código QR para realizar el pago automático o
                  utiliza tu método alternativo.
                </p>
              </div>

              {/* QR DE PAGO DINÁMICO */}
              <div
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "16px",
                  border: "1px solid #cbd5e1",
                  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.05)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h4
                  style={{
                    margin: "0 0 12px 0",
                    fontSize: "1rem",
                    color: "#0f172a",
                    fontWeight: "800",
                  }}
                >
                  Escanea para realizar el Pago Automático
                </h4>
                <div
                  style={{
                    padding: "10px",
                    background: "#fff",
                    borderRadius: "12px",
                    border: "1px solid #e2e8f0",
                    marginBottom: "12px",
                  }}
                >
                  {qrImagenBase64 ? (
                    <img
                      src={`data:image/png;base64,${qrImagenBase64}`}
                      alt="Código QR de Pago"
                      style={{
                        width: "180px",
                        height: "180px",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  ) : (
                    <p
                      style={{
                        fontSize: "0.8rem",
                        color: "#64748b",
                        padding: "40px 0",
                      }}
                    >
                      Generando QR de pago...
                    </p>
                  )}
                </div>
                <p
                  style={{
                    fontSize: "0.75rem",
                    color: "#64748b",
                    marginTop: "4px",
                    marginBottom: 0,
                  }}
                >
                  Tu anuncio se activará de forma automática al completarse el
                  pago.
                </p>
              </div>

         {/* ENLACE OPCIONAL CRIPTO SI APLICA - PRÓXIMAMENTE */}
<div
  style={{
    background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
    padding: "14px 16px",
    borderRadius: "12px",
    border: "1px solid #cbd5e1",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
  }}
>
  {/* Icono SVG de Criptomoneda / Moneda digital */}
  <div
    style={{
      background: "rgba(99, 102, 241, 0.1)",
      borderRadius: "10px",
      padding: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#6366f1",
      flexShrink: 0,
    }}
  >
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9"></circle>
      <path d="M14.8 9A2 2 0 0 0 13 8h-2a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4h-2a2 2 0 0 1-1.8-1"></path>
      <path d="M12 6v2"></path>
      <path d="M12 16v2"></path>
    </svg>
  </div>

  {/* Textos informativos */}
  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
    <span
      style={{
        fontSize: "0.75rem",
        color: "#4f46e5",
        fontWeight: "700",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
      }}
    >
      Próximamente
    </span>
    <p
      style={{
        fontSize: "0.8rem",
        color: "#334155",
        margin: 0,
        lineHeight: "1.3",
        fontWeight: "500",
      }}
    >
      Se podrá anunciar y pagar con criptomonedas para otros países.
    </p>
  </div>
</div>
              {/* COMPROBANTE OPCIONAL DE RESPALDO 
              <div
                style={{
                  background: "#fff1f2",
                  padding: "14px",
                  borderRadius: "12px",
                  border: "1px dashed #fecdd3",
                  textAlign: "left",
                }}
              >
                <label
                  style={{
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                    display: "block",
                    marginBottom: "6px",
                    color: "#9f1239",
                  }}
                >
                  (Opcional) Sube la captura de respaldo de tu comprobante:
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setComprobante(e.target.files[0])}
                  style={{ fontSize: "0.8rem", width: "100%" }}
                  
                />
              </div>
              
                  
              <button
                onClick={enviarComprobanteFinal}
                className="btn-create-account"
                style={{
                  marginTop: "6px",
                  background: "#22c55e",
                  boxShadow: "0 4px 12px rgba(34, 197, 94, 0.3)",
                }}
              >
                Enviar Comprobante y Finalizar ✓
              </button>*/}
            </>
          ) : (
            <div
              style={{
                background: "#f8fafc",
                padding: "30px 20px",
                borderRadius: "16px",
                border: "1px solid #e2e8f0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <div style={{ fontSize: "3rem" }}>🎉</div>
              <h3
                style={{
                  color: "#0f172a",
                  fontSize: "1.25rem",
                  margin: 0,
                  fontWeight: "800",
                }}
              >
                ¡Proceso completado!
              </h3>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#64748b",
                  lineHeight: "1.5",
                  maxWidth: "450px",
                  margin: 0,
                }}
              >
                Tu pago e información han sido procesados con éxito.
              </p>
              <button
                onClick={alCompletar}
                className="btn-create-account"
                style={{
                  marginTop: "10px",
                  background: "#ff2c55",
                  width: "auto",
                  padding: "12px 24px",
                }}
              >
                Volver a Mis Anuncios
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default CrearAnuncio;
